import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';

const DetailPage = lazy(() => import('@/pages/EntryRacer/Detail'));
const SearchPage = lazy(() => import('@/pages/EntryRacer/Search'));

const ErrorPage = lazy(() => import('@/pages/Error'));

const EntryRacerRoutes: FC = () => {
  return (
    <Switch>
      <Route path="detail">
        <Route index element={<DetailPage />}></Route>
      </Route>
      <Route path="search">
        <Route index element={<SearchPage />}></Route>
      </Route>

      <Route
        path="*"
        element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
      />
    </Switch>
  );
};

export default EntryRacerRoutes;
